// REDESIGNED TEMPLATE 5 AND 6 - MINIMALIST MODERN DESIGNS
import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// ========== TEMPLATE 5: Bold Orange Banner Design ==========
const FooterContainer5New = styled(Box)(({ theme }) => ({
  background: '#1e1e1e',
  color: 'white',
  padding: '0',
  borderRadius: '0 0 12px 12px',
  height: '100%',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
}));

const TopStrip5 = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(90deg, #ff6b35 0%, #f7931e 100%)',
  padding: '6px 12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0
}));

const BusinessName5 = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 700,
  color: '#ffffff',
  fontFamily: '"Inter", sans-serif',
  letterSpacing: '0.5px',
  textTransform: 'uppercase',
  textAlign: 'center',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: '100%'
}));

const ContentArea5 = styled(Box)(({ theme }) => ({
  padding: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center'
}));

const InfoRow5 = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px'
}));

const IconBox5 = styled(Box)(({ theme }) => ({
  width: '24px',
  height: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(135deg, #ff6b35, #f7931e)',
  borderRadius: '5px',
  flexShrink: 0,
  '& svg': {
    width: '12px',
    height: '12px',
    stroke: '#ffffff',
    strokeWidth: 2
  }
}));

const PhoneText5 = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 600,
  color: '#ff6b35',
  fontFamily: '"Inter", sans-serif'
}));

const AddressText5 = styled(Typography)(({ theme }) => ({
  fontSize: '11px',
  fontWeight: 500,
  color: '#ff6b35',
  fontFamily: '"Inter", sans-serif',
  lineHeight: 1.3,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical'
}));

export const TemplateFooter5New = ({ accountInfo, customColor, customFontColor }) => {
  const businessName = accountInfo?.businessName || 'STARTER BUSINESS';
  const contact = accountInfo?.contact || '+91 98765 43210';
  const address = accountInfo?.address || '123 Business Park, Main Road, City - 123456';

  return (
    <FooterContainer5New>
      <TopStrip5 sx={{ background: customColor ? `linear-gradient(90deg, ${customColor}, ${customColor}dd)` : undefined }}>
        <BusinessName5 sx={{ color: customFontColor || undefined }}>{businessName}</BusinessName5>
      </TopStrip5>
      <ContentArea5>
        <InfoRow5>
          <IconBox5 sx={{ background: customColor ? `linear-gradient(135deg, ${customColor}, ${customColor}dd)` : undefined }}>
            <svg viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
          </IconBox5>
          <PhoneText5 sx={{ color: customFontColor || customColor || '#ff6b35' }}>{contact}</PhoneText5>
        </InfoRow5>
        <InfoRow5>
          <IconBox5 sx={{ background: customColor ? `linear-gradient(135deg, ${customColor}, ${customColor}dd)` : undefined }}>
            <svg viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
          </IconBox5>
          <AddressText5 sx={{ color: customFontColor || customColor || '#ff6b35' }}>{address}</AddressText5>
        </InfoRow5>
      </ContentArea5>
    </FooterContainer5New>
  );
};

// ========== TEMPLATE 6: Modern Gradient Split Design ==========
const FooterContainer6New = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
  color: 'white',
  padding: '10px 14px',
  borderRadius: '0 0 12px 12px',
  height: '100%',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '8px'
}));

const TopSection6 = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  width: '100%'
}));

const BusinessCard6 = styled(Box)(({ theme }) => ({
  background: '#ffffff',
  padding: '6px 12px',
  borderRadius: '6px',
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
  flex: '1 1 auto',
  minWidth: 0
}));

const BusinessName6 = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 700,
  color: '#1a1a2e',
  fontFamily: '"Inter", sans-serif',
  letterSpacing: '0.2px',
  lineHeight: 1.3,
  wordBreak: 'break-word',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden'
}));

const PhonePill6 = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
  padding: '5px 8px',
  borderRadius: '20px',
  boxShadow: '0 2px 10px rgba(17, 153, 142, 0.4)',
  flexShrink: 0
}));

const PhoneIcon6 = styled(Box)(({ theme }) => ({
  width: '16px',
  height: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': {
    width: '12px',
    height: '12px',
    stroke: '#ffffff',
    strokeWidth: 2.5
  }
}));

const PhoneText6 = styled(Typography)(({ theme }) => ({
  fontSize: '11px',
  fontWeight: 600,
  color: '#ffffff',
  fontFamily: '"Inter", sans-serif',
  letterSpacing: '0.3px',
  whiteSpace: 'nowrap'
}));

const AddressBar6 = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  gap: '8px',
  padding: '8px 10px',
  background: 'rgba(255, 255, 255, 0.08)',
  borderRadius: '6px',
  borderLeft: '3px solid #38ef7d'
}));

const LocationIcon6 = styled(Box)(({ theme }) => ({
  width: '20px',
  height: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(56, 239, 125, 0.2)',
  borderRadius: '4px',
  flexShrink: 0,
  '& svg': {
    width: '12px',
    height: '12px',
    stroke: '#38ef7d',
    strokeWidth: 2
  }
}));

const AddressText6 = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 700,
  color: 'rgba(255, 255, 255, 0.95)',
  fontFamily: '"Inter", sans-serif',
  lineHeight: 1.4,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical'
}));

const BottomAccent6 = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: '3px',
  background: 'linear-gradient(90deg, #11998e, #38ef7d, #11998e)',
  opacity: 0.8
}));

export const TemplateFooter6New = ({ accountInfo, customColor, customFontColor }) => {
  const businessName = accountInfo?.businessName || 'STARTER BUSINESS';
  const contact = accountInfo?.contact || '+91 98765 43210';
  const address = accountInfo?.address || '123 Business Park, Main Road, City - 123456';

  return (
    <FooterContainer6New sx={{ background: customColor || undefined, color: customFontColor || undefined }}>
      <TopSection6>
        <BusinessCard6>
          {/* Don't apply customFontColor here - the card has white background, so text must stay dark */}
          <BusinessName6>{businessName}</BusinessName6>
        </BusinessCard6>

        <PhonePill6>
          <PhoneIcon6>
            <svg viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
          </PhoneIcon6>
          <PhoneText6 sx={{ color: customFontColor || undefined }}>{contact}</PhoneText6>
        </PhonePill6>
      </TopSection6>

      <AddressBar6>
        <LocationIcon6>
          <svg viewBox="0 0 24 24" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
        </LocationIcon6>
        <AddressText6 sx={{ color: customFontColor || undefined }}>{address}</AddressText6>
      </AddressBar6>

      <BottomAccent6 />
    </FooterContainer6New>
  );
};
